import type { FC } from "react";
import type { InputProps } from "../../DynamicInput";
import { TenantMultiSelect } from "../../shared/TenantMultiSelect";
import { inlineInputStateStyles } from "./InlineInputState";

export const TenantMulti: FC<InputProps<string[]>> = props => (
  <TenantMultiSelect inlineInputStateStyles={inlineInputStateStyles} {...props} />
);
